<template>
	<VCard
		outlined
		color="am-blue-lighten-97"
		class="pa-4 rounded-lg"
	>
		<slot />
	</VCard>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component, { mixins } from 'vue-class-component';

	const props = Vue.extend({
		props: {
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: 'max-content'
			}
		}
	});
	@Component
	export default class CardItem extends mixins(props) {}
</script>

<style lang="scss" scoped>
	@import '@cnamts/design-tokens/dist/tokens';

	.card-border {
		border: solid 1px $vd-am-blue-lighten-90;
	}
</style>
